import { brand } from '../../../theme/themePrimitives';
import { DealObject } from '../../../params/pipeline';
import DeleteDealModal from '../../deal/modal/delete_deal';
import { fetchDealDetailThunk } from '../../../redux/thunks/deal';
import ImageClass from '../../../assets';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { setEditDeal, settingSelectedDeal, settingViewDetail } from '../../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';


interface DealsRow {
    id: number;
    company: string;
    position: string;
    name: string;
    email: string;
    phone: string;
}

interface RoloDexTableProps {
    search: string;
    sort: boolean;
}

const RoloDexTable = ({ search, sort }: RoloDexTableProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const { deals, loaders } = useSelector((state: RootState) => state.deal);
    // **Filter and Sort Logic**
    const filteredDeals = deals.filter((deal: DealObject) => {
        const company = deal.company?.toLowerCase() || '';
        const email = deal.email?.toLowerCase() || '';
        const phone = deal.phone || '';
        return (
            !search ||
            company.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            phone.includes(search)
        );
    });

    const sortedDeals = sort
        ? [...filteredDeals].sort((a, b) => a.company.localeCompare(b.company))
        : filteredDeals;

    const rows: DealsRow[] = sortedDeals.map((deal: DealObject) => ({
        id: deal.id,
        company: deal.company || '',
        position: '',
        name: deal.title || '',
        email: deal.email || '',
        phone: deal.phone || ''
    })) || [];

    const handleViewSelection = (value: number) => {
        const selectedDeal = deals.find((item: DealObject) => item.id === value);
        dispatch(settingSelectedDeal(selectedDeal));
        dispatch(settingViewDetail(true));
        dispatch(setEditDeal(false));
        navigate('/app/deals');
    };

    const handleDeleteSelection = (value: number) => {
        const selectedDeal = deals.find((item: DealObject) => item.id === value);
        dispatch(settingSelectedDeal(selectedDeal));
        setShowDeleteModal(true);
    };

    const editDealHandler = async (value: number) => {
        try {
            const selectedDeal = deals.find((item: DealObject) => item.id === value);
            await dispatch(fetchDealDetailThunk(selectedDeal?.id || 0));
            dispatch(setEditDeal(true));
            navigate('/app/deals');
        } catch (error) {
            //
        }
    };

    const columns: GridColDef<DealsRow>[] = [
        {
            field: 'company',
            headerName: 'COMPANY',
            flex: 1,
            renderCell: (params: GridRenderCellParams<DealsRow, string>) => <Box display="flex" alignItems="center" my={1}>
                <Avatar
                    src={ImageClass.userImage}
                    alt="User"
                    sx={{
                        height: '30px',
                        width: '30px',
                        marginRight: '10px',
                        border: `1px solid ${brand[300]}`
                    }}
                />
                <Typography variant="body2">{params.value}</Typography>
            </Box>
        },
        { field: 'position', headerName: 'POSITION', flex: 1 },
        { field: 'name', headerName: 'NAME', flex: 1 },
        { field: 'email', headerName: 'EMAIL', flex: 1 },
        { field: 'phone', headerName: 'PHONE NUMBER', flex: 1 },
        {
            field: 'id',
            headerName: 'ACTIONS',
            flex: 1,
            renderCell: (params: GridRenderCellParams<DealsRow, number>) => <Box display="flex" alignItems="center" gap="2px">
                <IconButton onClick={() => handleViewSelection(params.value as number)}>
                    <Visibility fontSize="small" color="info" />
                </IconButton>
                <IconButton onClick={() => editDealHandler(params.value as number)}>
                    <Edit fontSize="small" color="info" />
                </IconButton>
                <IconButton onClick={() => handleDeleteSelection(params.value as number)}>
                    <Delete fontSize="small" color="error" />
                </IconButton>
            </Box>
        }
    ];

    return <Box height="70vh" width="100%">
        <DataGrid
            rows={rows as DealsRow[]}
            loading={loaders.isLoading}
            columns={columns}
            pagination
            // slots={{
            //     pagination: CustomPagination
            // }}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 20
                    }
                }
            }}
            sx={{
                '& .MuiDataGrid-row--borderBottom': {
                    backgroundColor: `${brand[50]} !important`
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 'bold'
                },
                '& .MuiDataGrid-columnHeaders': {
                    fontWeight: 'bold'
                },
                '& .MuiDataGrid-cell': {
                    fontSize: '14px'
                },
                'width': '100%',
                'overflowX': 'hidden'
            }}
        />
        {showDeleteModal && <DeleteDealModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} />}
    </Box>;
};

export default RoloDexTable;